import React, { useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { placementStyle, useAnchoredPosition } from './anchoredPosition'
import { useOverlayZIndex } from './overlayZIndex'
import { OVER_LIMIT_TOOLTIP_HEADING, overLimitTooltipLine } from './layoutBuilderCopy'
import './layoutBuilder.css'

// Rendered (so it can be measured) but invisible until its first placement, which happens before paint.
const HIDDEN_UNTIL_PLACED = { left: 0, top: 0, visibility: 'hidden' }

// Amber warning icon for an integration tab. `overLimit` is the over-limit entries of
// usageForCatalogFlowTypes. The tooltip shows on hover or keyboard focus. It is portaled to
// document.body and positioned from the icon's rect (and kept there on scroll/resize, flipping
// above when there is no room below), because the tab strip scrolls (overflow:auto)
// and would clip an in-place tooltip. The icon's accessible name carries the same text.
export default function OverLimitIndicator ({ overLimit }) {
  const [open, setOpen] = useState(false)
  const iconRef = useRef(null)
  const tooltipRef = useRef(null)
  const position = useAnchoredPosition(open, iconRef, tooltipRef)
  useOverlayZIndex(open, tooltipRef)
  if (overLimit.length === 0) return null
  const lines = overLimit.map(overLimitTooltipLine)

  const show = () => setOpen(true)
  const hide = () => setOpen(false)

  return (
    <span
      ref={iconRef}
      className='layoutBuilder-over-limit-indicator'
      role='img'
      tabIndex={0}
      aria-label={`${OVER_LIMIT_TOOLTIP_HEADING}: ${lines.join('; ')}`}
      onMouseEnter={show}
      onMouseLeave={hide}
      onFocus={show}
      onBlur={hide}
    >
      <i className='pi pi-exclamation-triangle' aria-hidden='true' />
      {open && createPortal(
        <span
          ref={tooltipRef}
          className='layoutBuilder-over-limit-tooltip'
          role='tooltip'
          aria-hidden='true'
          style={position ? placementStyle(position) : HIDDEN_UNTIL_PLACED}
        >
          <strong>{OVER_LIMIT_TOOLTIP_HEADING}</strong>
          <ul>
            {lines.map(line => <li key={line}>{line}</li>)}
          </ul>
        </span>,
        document.body
      )}
    </span>
  )
}
